import GradeLessonPage from '../components/GradeLessonPage';
import { grade1Topics } from './data';

export default function Grade1Page() {
  return (
    <GradeLessonPage
      grade="1"
      gradeLabel="Grade 1"
      gradeColor="teal"
      topics={grade1Topics}
      prevGrade={{ label: 'Kindergarten', path: '/grade/k' }}
      nextGrade={{ label: 'Grade 2', path: '/grade/2' }}
    />
  );
}
